import React from 'react';
import { Route, Switch } from 'react-router-dom';
import StandardPageTemplate from '../../common/components/Layout/StandardPageTemplate';
import PageNotFound from '../../common/components/NotFound/PageNotFound';
import ForgotPW from './Views/ForgotPW';
import Login from './Views/Login';
import Logout from './Views/Logout';
import ResetPW from './Views/ResetPW';
import UnauthMatch from './Views/UnauthMatch';

const Entry = ({ match: { path } }) => {
  return (
    <StandardPageTemplate>
      <Switch>
        <Route path={`${path}/logout`} component={Logout} />
        <UnauthMatch path={`${path}/forgot`} component={ForgotPW} />
        <UnauthMatch path={`${path}/reset`} component={ResetPW} />
        <UnauthMatch path={`${path}/login`} component={Login} />
        <Route component={PageNotFound} />
      </Switch>
    </StandardPageTemplate>
  );
};
export default Entry;



// WEBPACK FOOTER //
// ./src/App/auth/index.js